import {useEffect} from 'react';

import {useHttpClient} from 'hooks';

export default function useSupportedDrupalVersions() {
  const {data, loading, cancel, error} = useHttpClient({
    url: `/api/drupal/supported-versions`,
    method: 'GET',
  });

  useEffect(() => {
    return () => {
      cancel('Request to /api/drupal/supported-versions has been cancelled');
    };
  }, [cancel]);

  return {
    isLoading: loading,
    supportedDrupalVersions: data && !loading ? data.supportedVersions : [],
    error,
  };
}
